<template>
  <div>
    <div v-if="roleId === ''">
      <div class="my-code">点击角色查看用户</div>
    </div>
    <div v-else>
      <!--工具栏-->
      <div class="head-container">
        <!-- 搜索 -->
        <dynamic-search
          :data="tableFilterList(tableHead)"
          @search="dataTableSearch">
          <template v-slot:next>
            <!-- 选择用户-->
            <dynamic-data-box
              :props="{label: 'name',value: 'id'}"
              hostUrl="/user/list"
              :value="users"
              v-on="$listeners"
              :tableColumn="tableHead"
              :multiple="true"
              :trigger="trigger"
              @change="handleChangeEvent($event)"
              @confirm="saveUser">
            </dynamic-data-box>
          </template>
        </dynamic-search>
      </div>
      <!--表格渲染-->
      <edit-data-table
        :loading="loading"
        :head="tableHead"
        ref="editTable"
        :enableEdit="false"
        :checkbox="true"
        height
        :data.sync="list"
        :total="total"
        :offset="offset"
        :page="page"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange">
          <template v-slot:toolbar="{row}">
            <el-popover
              :ref="row.userRoleId"
              placement="top"
              width="180">
              <p>确定删除本条数据吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="$refs[row.userRoleId].doClose()">取消</el-button>
                <el-button :loading="delLoading" type="primary" size="mini" @click="subDelete(row.userRoleId)">确定</el-button>
              </div>
              <el-button slot="reference" type="text" icon="el-icon-delete" class="table-del-btn" size="mini"/>
            </el-popover>
          </template>
          <template v-slot:state="{row}">
            <el-tag :type="row.enabled ? '' : 'info'">{{ row.enabled ? '启用' : '禁用'}}</el-tag>
          </template>
      </edit-data-table>
    </div>
  </div>
</template>

<script>
import '@/components/EditDataTable';
import DataTableMixin from '@/mixins/DataTableMixin';
import { delUser, editUser } from '@/api/role'
import DynamicSearch from '@/components/DynamicSearch/index.vue'
export default {
  components: { DynamicSearch },
  mixins: [DataTableMixin],
  props: {
    dicts: {
      type: Array,
       default: () => ([])
    }
  },
  data() {
    return {
      delLoading: false,
      tableHead: [
        { label: '编码', prop: 'code' },
        { label: '名称', prop: 'name', property: 'name', query: { type: 'input' }, sortable: true },
        { label: '岗位', prop: 'postName'}
      ],
      trigger: {type: 'button', title: '选择用户', btnType: 'primary' },
      roleId: '',
      users: []
    }
  },
  created() {
      this.loading = false
  },
  methods: {
    dataTableBeforeInit() {
        this._url = '/role/users'
        const query = this._query
        const params = { page: this.page, size: this.offset, id: this.roleId}
        this._params = Object.assign(params,query)
        return true
    },
    subDelete(id) {
      this.delLoading = true
      delUser([id]).then(res => {
        this.delLoading = false
        this.$refs[id].doClose()
        this.dleTableChangePage()
        this.dataTableInit()
        this.$notify({
          title: '删除成功',
          type: 'success',
          duration: 2500
        })
      }).catch(err => {
        this.delLoading = false
        this.$refs[id].doClose()
        console.log(err)
      })
    },
    handleDeletes(rows) {
      const ids = []
      rows.forEach(element => {
          ids.push(element.userRoleId)
      });

      delUser(ids).then(res => {
        this.dleTableChangePage()
        this.dataTableInit()
        this.$notify({
          title: '删除成功',
          type: 'success',
          duration: 2500
        })
      }).catch(err => {
        console.log(err)
      })
    },
    handleChangeEvent(val) {
        this.users = val
    },
    saveUser(val) {
      const _this = this
      _this.loading = true
      const role = { id: this.roleId, users: [] }
      val.forEach(ele => {
         role.users.push(ele.id)
      })
      editUser(role).then(res => {
        this.$notify({
          title: '保存成功',
          type: 'success',
          duration: 2500
        })
        _this.loading = false
        _this.dataTableInit()
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
